var loadContent = {};

loadContent.xslTemplate;
loadContent.DDBxslTemplate;
loadContent.pathToDoc = "";
loadContent.langue = "";
loadContent.racine = "";
loadContent.racineXSL = "";
loadContent.racineTemplates = "";
loadContent.last_consultation = "";

loadContent.loadContent = async function (page, params) {

	const pageURL = page
	loadContent.last_consultation = pageURL

	if (params === undefined) {
		params.targetSelector = null;
		params.initDoc = null;
	}

	return $.ajax({
		url: pageURL
		, global: false
		, dataType: "xml"
		, success: loadContent.loadPageDone
		, error: loadContent.loadPageError
		, params: params
	})
}

loadContent.loadContentXML = function (page, successCallback, failCallback) {
	return $.ajax({
		url: page
		, global: false
		, dataType: "xml"
		, success: successCallback
		, error: failCallback
	});
}

loadContent.loadContentXMLwithMetadatas = function (page, successCallback, failCallback, metadatas, persistantMetadatas) {
	var jqxhr = loadContent.loadContentXML(loadContent.racine + "/" + page, successCallback, failCallback);
	jqxhr.papMetadatas = metadatas;
	jqxhr.papPersistantMetadatas = persistantMetadatas;
}

loadContent.loadContentDoc = function (page, successCallback, failCallback, handleHistory) {
	const pageURL = loadContent.racine + "/" + page;
	loadContent.last_consultation = page;

	$.ajax({
		url: pageURL
		, global: false
		, dataType: "xml"
		, success: successCallback
		, error: failCallback
		, papParameters: { handleHistory: handleHistory, urlHistory: page }
	});
}

loadContent.loadContentScanView = function (page, successCallback, failCallback) {
	const pageURL = page;
	loadContent.last_consultation = pageURL;
	$.ajax({
		url: pageURL
		, global: false
		, dataType: "xml"
		, success: successCallback
		, error: failCallback
	});
}

loadContent.loadPageError = function (jqXHR, textStatus, errorThrown) {
	notification.errorOpenConsultation(function () { });
}

loadContent.loadPageDone = function (data, textStatus, jqXHR) {
	let targetSelector = this.params.targetSelector;
	if (targetSelector === undefined || targetSelector == null) {
		targetSelector = "app-content";
	}

	let initDoc = this.params.initDoc;
	if (initDoc === undefined || initDoc == null) {
		initDoc = false;
	}

	loadContent.pageContentLoaded(data, targetSelector, initDoc)
}

function logMessage(title, message) {
    // make sure if the 'console' object and its methods are available,
    // to avoid issues, like your JS code is broken by logging.
    // see: https://stackoverflow.com/a/7742862/704022
    if (console && console.log && console.group && console.groupEnd) {
        var maxLength = 1024; // set to 10 to enable easier testing, should be 1024
        console.group(title);
        for (var pos = 0; pos < message.length ; pos += maxLength) {
            console.log(message.substring(pos, pos + maxLength));
        }
        console.groupEnd();
    }
}

loadContent.transformContentWithXSL = function (xmlData, xslData, dataTypeScreen) {
	if (window.ActiveXObject) {
		var xml = new ActiveXObject("MSXML2.DOMDocument");
		xml.async = false
		var strXmlData = new XMLSerializer().serializeToString(xmlData);
		var utfFilter = new RegExp('\u00AD|&shy;', 'gm')
		strXmlData = strXmlData.replace(utfFilter, '');
		xml.loadXML(strXmlData);
		if ( xml.parseError.errorCode !== 0 ) {
			console.log("XML parsing Error : " + xml.parseError.reason);
		}

		var xslt = new ActiveXObject("MSXML2.FreeThreadedDOMDocument");
		xslt.async = false;
		xslt.load(loadContent.racineXSL + "doc/xsl/documentation.xsl");

		var processor = new ActiveXObject("MSXML2.XSLTemplate");
		processor.stylesheet = xslt;

		var xsltProcessor = processor.createProcessor();
		xsltProcessor.addParameter("pathToDoc", loadContent.pathToDoc);
		if (dataTypeScreen) xsltProcessor.addParameter("data-type-screen", dataTypeScreen);
		xsltProcessor.addParameter("action-title", loadDDB.lightsActionsObservationsTitle);
		for (var key in docParams.params) {
			xsltProcessor.addParameter(key, docParams.params[key]);
		}

		if (psa_params.data.xsldebug === true) {
			xsltProcessor.setParameter("xsldebug", 'true');
		}
		if (psa_params.data.modeEGuide === true) {
			xsltProcessor.addParameter("mode-eguide", 'true');
		}
		xsltProcessor.input = xml;
		xsltProcessor.transform();
		var output = xsltProcessor.output;

		return $(output);
	}
	else {
		var xsltProcessor = new XSLTProcessor();
		xsltProcessor.setParameter(null, "pathToDoc", loadContent.pathToDoc);
		if (dataTypeScreen) xsltProcessor.setParameter(null, "data-type-screen", dataTypeScreen);
		xsltProcessor.setParameter(null, "action-title", loadDDB.lightsActionsObservationsTitle);
		for (var key in docParams.params) {
			xsltProcessor.setParameter(null, key, docParams.params[key]);
		}

		if (psa_params.data.xsldebug) {
			xsltProcessor.setParameter(null, "xsldebug", 'true');
		}

		if (psa_params.data.modeEGuide) {
			xsltProcessor.setParameter(null, "mode-eguide", 'true');
		}
		xsltProcessor.importStylesheet(xslData);
		var output = xsltProcessor.transformToFragment(xmlData, document);
		return output;
	}
}

loadContent.transformContentToTitleWithXSL = function (xml, xsl, dataTypeScreen, topicID, language, resolutionMode) {
	const xsltProcessor = new XSLTProcessor();
	xsltProcessor.setParameter(null, "pathToDoc", loadContent.pathToDoc);
	if (dataTypeScreen) xsltProcessor.setParameter(null, "data-type-screen", dataTypeScreen);
	xsltProcessor.setParameter(null, "action-title", loadDDB.lightsActionsObservationsTitle);
	for (const key in docParams.params) {
		if (docParams.params.hasOwnProperty(key)) {
			xsltProcessor.setParameter(null, key, docParams.params[key]);
		}
	}

	xsltProcessor.setParameter(null, "xsldebug", psa_params.data.xsldebug === undefined ? "" : psa_params.data.xsldebug);
	xsltProcessor.setParameter(null, "topicID", topicID === undefined ? "" : topicID);
	xsltProcessor.setParameter(null, "langue", language === undefined ? "" : language);
	xsltProcessor.setParameter(null, "context", context.context === undefined ? "" : context.context);

	let scheme = "";
	if ( typeof device !== "undefined" && device.platform.toLowerCase() === "ios" ) {
		scheme = "scanmycar-images://";
	}
	xsltProcessor.setParameter(null, "scheme", scheme);

	if ( resolutionMode === undefined ) {
		resolutionMode = "default";
	}

	xsltProcessor.setParameter(null, "resolutionMode", resolutionMode);

	xsltProcessor.importStylesheet(xsl);
	return xsltProcessor.transformToFragment(xml, document);
}

loadContent.transformContentDDB = function (xml, dataTypeScreen) {
	var content
	if (psa_params.data.modeEGuide) {
		content = convertirTableauxTemoinseGuide(loadContent.transformContentWithXSL(xml, loadContent.DDBxslTemplate, dataTypeScreen), loadContent.pathToDoc);
	} else {
		content = convertirTableauxTemoins(loadContent.transformContentWithXSL(xml, loadContent.DDBxslTemplate, dataTypeScreen), loadContent.pathToDoc, loadDDB.lightsActionsObservationsTitle);
	}
	tableStyler.style(content)
	return content
}

loadContent.transformContent = function (xml) {
	return loadContent.transformContentWithXSL(xml, loadContent.xslTemplate);
}

loadContent.pageContentLoaded = function (htmlText, targetSelector, initDoc) {
	const oldTargetSelector = "old-" + targetSelector;
	const $newContent = $("<div/>").attr('id', targetSelector);

	$newContent.append($(htmlText).children());
	applicability.filter($newContent);

	if (initDoc) {
		footerController.loadFooterApp($newContent)
	} else {
		headerController.loadHeaderApp($newContent)
	}

	callInitPage($newContent, oldTargetSelector, targetSelector)
}

function callInitPage($newcontent, oldTargetSelector, targetSelector) {
	$($newcontent).find("[data-i18n]").i18n();

	$("#" + oldTargetSelector).remove();
	let $oldContent = $("#" + targetSelector).attr('id', oldTargetSelector);

	$oldContent.after($newcontent);
	$oldContent.remove();

	pap.initPage()
}

loadContent.loadXSLTemplate = function (pageURL, onsuccess, onerror) {
	$.ajax({
		url: pageURL
		, global: false
		, context: document.body
		, dataType: "xml"
		, success: onsuccess
		, error: onerror
	});
}

loadContent.loadTemplate = function (callback) {
	function loadDDBTemplate(callbackLoadDDBTemplate) {
		if (psa_params.data.modeXSL === true) {
			loadContent.loadXSLTemplate(loadContent.racineXSL + "doc/xsl/documentation.xsl", function success(data, textStatus, jqXHR) {
				loadContent.loadTemplateDDBDone(data, textStatus, jqXHR)
				callbackLoadDDBTemplate.apply(this, [])
			}, function error(jqXHR, textStatus, errorThrown) {
				loadContent.loadTemplateError(jqXHR, textStatus, errorThrown)
				callbackLoadDDBTemplate.apply(this, [])
			})
		}

	}

	function loadTemplateDoc(callbackLoadTemplateDoc) {
		if (psa_params.data.modeXSL === true) {
			var pageURL = loadContent.racineXSL + "doc/xsl/documentation_dummy.xsl";

			loadContent.loadXSLTemplate(pageURL, function success(data, textStatus, jqXHR) {
				loadContent.loadTemplateDone(data, textStatus, jqXHR)
				callbackLoadTemplateDoc.apply(this, [])
			}, function error(jqXHR, textStatus, errorThrown) {
				loadContent.loadTemplateError(jqXHR, textStatus, errorThrown)
				callbackLoadTemplateDoc.apply(this, [])
			})
		}
	}

	loadDDBTemplate(function () {
		loadTemplateDoc(function () {
			callback.apply(this, [])
		})
	})

}

loadContent.loadTemplateError = function (jqXHR, textStatus, errorThrown) {
	console.log("loadTemplateError : " + errorThrown);
}

loadContent.loadTemplateDone = function (data, textStatus, jqXHR) {
	loadContent.xslTemplate = data;
}

loadContent.loadTemplateDDBDone = function (data, textStatus, jqXHR) {
	loadContent.DDBxslTemplate = data;
}